import { css } from '@emotion/react';
import { fontFamily } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

// NOTE: @atlaskit/onboarding Spotlight is rendered using @atlaskit/portal
// Portal renders as a direct body of the <body> elment in the DOM
// Spotlight will not inherit any styles from its parent component

export const adsFont = css`
  color: ${token('color.text.inverse', '#1D2125')};
  font-family: ${fontFamily()};
  font-size: ${token('font.size.100', '14px')};
  line-height: ${token('font.lineHeight.200', '1.42857142857143')};
`;

export const spotlightHeader = css`
  margin-top: 0;
  font-weight: bold;
  margin-bottom: 15px;
`;
